import vPermission from './v-permission'
import vRole from './v-role'
export default (Vue, { store }) => {
  Vue.directive('permission', vPermission(store))
  Vue.directive('role', vRole(store))
}
